import {
  type TrendingListItemResponse,
  type TrendingListItemResponseTrendingListResponseRelatedPagedData,
} from '@on3/api';
import { Brands } from '@on3/ui-lib/components/Brands';
import { Tag } from '@on3/ui-lib/components/Tag';
import { webUrl } from '@on3/ui-lib/utils/api';

import styles from './TopHeadlines.module.scss';

export const TopHeadlines = ({
  data,
  viewAllUrl,
}: {
  data: TrendingListItemResponseTrendingListResponseRelatedPagedData;
  viewAllUrl: string;
}) => {
  const { list = [], relatedModel } = data;

  return (
    <section
      aria-labelledby="top-headlines"
      className={styles.block}
      role="complementary"
    >
      <h2 className={styles.title} id="top-headlines">
        {relatedModel?.displayName ?? relatedModel?.name ?? 'Top 10'}
        <div className={styles.logos}>
          <Brands variant="small" />
        </div>
      </h2>
      <ol aria-live="polite" className={styles.list}>
        {list.map((item: TrendingListItemResponse, index) => (
          <li key={item.key}>
            <a
              className={styles.listItem}
              href={item.url ?? ''}
              target="_parent"
              title={item.headline ?? ''}
            >
              <span className={styles.index}>{index + 1}</span>
              <div className={styles.content}>
                <div>
                  <h3>{item.subject}</h3>
                  <p>{item.headline}</p>
                </div>
                <Tag type={item.type} />
              </div>
            </a>
          </li>
        ))}
      </ol>
      {viewAllUrl && (
        <a
          className={styles.viewAll}
          href={webUrl + viewAllUrl}
          target="_parent"
          title="On3"
        >
          View All
        </a>
      )}
    </section>
  );
};
